import { Link } from "react-router-dom";
import "../styles/footer.css";

export default function Footer() {
  const phoneNumber = "919983765215";

  const whatsappMessage = encodeURIComponent(
    "Hi VK Bike On Rent, I want to enquire about your rental services in Udaipur."
  );

  const whatsappUrl = `https://wa.me/${phoneNumber}?text=${whatsappMessage}`;

  const mapsUrl =
    "https://www.google.com/maps/search/?api=1&query=HMJM%2B296%2C%20Jagdish%20Chowk%2C%20Udaipur%2C%20Rajasthan%20313004";

  return (
    <footer className="footer">
      <div className="footer-container">

        {/* ================= BUSINESS ================= */}

        <section
          className="footer-col footer-business"
          aria-labelledby="footer-business-title"
        >
          <h2 id="footer-business-title">
            VK Bike On Rent
          </h2>

          <p>
            Bike, scooty and taxi rental services in Udaipur,
            Rajasthan. Explore Udaipur and nearby destinations
            with convenient rental options for your trip.
          </p>

          <a
            href={whatsappUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="footer-whatsapp"
          >
            💬 Enquire on WhatsApp
          </a>
        </section>

        {/* ================= QUICK LINKS ================= */}

        <nav
          className="footer-col"
          aria-labelledby="footer-navigation-title"
        >
          <h3 id="footer-navigation-title">
            Quick Links
          </h3>

          <Link to="/">Home</Link>

          <Link to="/bikes">
            Bike & Scooty Rental in Udaipur
          </Link>

          <Link to="/taxi">
            Taxi & Cab Services in Udaipur
          </Link>

          <Link to="/horse-riding">
            Horse Riding in Udaipur
          </Link>

          <Link to="/contact">
            Contact VK Bike On Rent
          </Link>
        </nav>

        {/* ================= CONTACT ================= */}

        <section
          className="footer-col"
          aria-labelledby="footer-contact-title"
        >
          <h3 id="footer-contact-title">
            Contact VK Bike On Rent
          </h3>

          <address>

            <p>
              <span aria-hidden="true">📍</span>{" "}
              <strong>Address:</strong>
              <br />

              <a
                href={mapsUrl}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="View VK Bike On Rent location on Google Maps"
              >
                HMJM+296, Near Sai Baba Temple,
                <br />
                Jagdish Temple Road, Jagdish Chowk,
                <br />
                Udaipur, Rajasthan 313004, India
              </a>
            </p>

            <p>
              <span aria-hidden="true">📞</span>{" "}
              <strong>Phone:</strong>
              <br />

              <a
                href={`tel:+${phoneNumber}`}
                aria-label="Call VK Bike On Rent"
              >
                +91 99837 65215
              </a>
            </p>

            <p>
              <span aria-hidden="true">💬</span>{" "}
              <strong>WhatsApp:</strong>
              <br />

              <a
                href={whatsappUrl}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Contact VK Bike On Rent on WhatsApp"
              >
                Chat on WhatsApp
              </a>
            </p>

            <p>
              <span aria-hidden="true">🕒</span>{" "}
              <strong>Hours:</strong>
              <br />
              Open 24 Hours
            </p>

          </address>
        </section>

      </div>

      {/* ================= FOOTER BOTTOM ================= */}

      <div className="footer-bottom">
        <p>
          © {new Date().getFullYear()} VK Bike On Rent.
          All Rights Reserved.
        </p>

        <p>
          Bike & Scooty Rental in Udaipur, Rajasthan
        </p>
      </div>
    </footer>
  );
}